import { makeObservable, observable } from 'mobx';

import FiltroAcordaosEncaminhadosPje from './filtros/FiltroAcordaosEncaminhadosPje';
import FiltroAdvogadoModoParticipacao from './filtros/FiltroAdvogadoModoParticipacao';
import FiltroAdvogadoNome from './filtros/FiltroAdvogadoNome';
import FiltroAdvogadoPreferenciaSustentacaoOralPresenca from './filtros/FiltroAdvogadoPreferenciaSustentacaoOralPresenca';
import FiltroAdvogadoPreferenciaSustentacaoOralUfOab from './filtros/FiltroAdvogadoPreferenciaSustentacaoOralUfOab';
import FiltroAdvogadoPreferenciaSustentacaoOralUfOabOutraUf from './filtros/FiltroAdvogadoPreferenciaSustentacaoOralUfOabOutraUf';
import FiltroAnotacoes from './filtros/FiltroAnotacoes';
import FiltroAnotacoesComplementares from './filtros/FiltroAnotacoesComplementares';
import FiltroAnotacoesCurtas from './filtros/FiltroAnotacoesCurtas';
import FiltroCertidaoPendente from './filtros/FiltroCertidaoPendente';
import FiltroCertidoesEncaminhadasPje from './filtros/FiltroCertidoesEncaminhadasPje';
import FiltroClasseJudicial from './filtros/FiltroClasseJudicial';
import FiltroClasseJudicialCompleta from './filtros/FiltroClasseJudicialCompleta';
import FiltroComposicao from './filtros/FiltroComposicao';
import FiltroCorreJunto from './filtros/FiltroCorreJunto';
import FiltroDestaques from './filtros/FiltroDestaques';
import FiltroDestaquesPorMagistrado from './filtros/FiltroDestaquesPorMagistrado';
import FiltroDomicilioEletronico from './filtros/FiltroDomicilioEletronico';
import FiltroGabineteRelator from './filtros/FiltroGabineteRelator';
import FiltroImpedimentos from './filtros/FiltroImpedimentos';
import FiltroImpedimentosMagistrado from './filtros/FiltroImpedimentosMagistrado';
import FiltroIncluidoPeloGabinete from './filtros/FiltroIncluidoPeloGabinete';
import FiltroIndicadores from './filtros/FiltroIndicadores';
import FiltroInformacaoIntimacao from './filtros/FiltroInformacaoIntimacao';
import FiltroIntimacaoDomicilioEletronico from './filtros/FiltroIntimacaoDomicilioEletronico';
import FiltroMesmaFaseSessaoAnterior from './filtros/FiltroMesmaFaseSessaoAnterior';
import FiltroMotivoRemessaJulgamento from './filtros/FiltroMotivoRemessaJulgamento';
import FiltroMovimentoDecisao from './filtros/FiltroMovimentoDecisao';
import FiltroMovimentoDecisaoJulgadoSessaoAnterior from './filtros/FiltroMovimentoDecisaoJulgadoSessaoAnterior';
import FiltroMovimentoDecisaoSessaoAnterior from './filtros/FiltroMovimentoDecisaoSessaoAnterior';
import FiltroMovimentosEncaminhadosPje from './filtros/FiltroMovimentosEncaminhadosPje';
import FiltroMovimentosOuDecisaoAusentes from './filtros/FiltroMovimentosOuDecisaoAusentes';
import FiltroNomeRelator from './filtros/FiltroNomeRelator';
import FiltroNumeroProcesso from './filtros/FiltroNumeroProcesso';
import FiltroObrigatoriedadePublicacaoAcordao from './filtros/FiltroObrigatoriedadePublicacaoAcordao';
import FiltroOrigem from './filtros/FiltroOrigem';
import FiltroPartes from './filtros/FiltroPartes';
import FiltroPeticoesPendentes from './filtros/FiltroPeticoesPendentes';
import FiltroProcessoImportadoSIJ from './filtros/FiltroProcessoImportadoSIJ';
import FiltroProcessoLiberadoPelaSecretaria from './filtros/FiltroProcessoLiberadoPelaSecretaria';
import FiltroProcessosAssociados from './filtros/FiltroProcessosAssociados';
import FiltroQuantidadePartesAutoras from './filtros/FiltroQuantidadePartesAutoras';
import FiltroQuorum from './filtros/FiltroQuorum';
import FiltroQuorumMinimo from './filtros/FiltroQuorumMinimo';
import FiltroRegiaoProcesso from './filtros/FiltroRegiaoProcesso';
import FiltroResultadoApreciacaoSessaoAnterior from './filtros/FiltroResultadoApreciacaoSessaoAnterior';
import FiltroResultadosApreciacaoSessoesAnteriores from './filtros/FiltroResultadosApreciacaoSessoesAnteriores';
import FiltroRetornoAdiamento from './filtros/FiltroRetornoAdiamento';
import FiltroRetornoVistaRegimental from './filtros/FiltroRetornoVistaRegimental';
import Filtros from './filtros/Filtros';
import FiltroSegredoJustica from './filtros/FiltroSegredoJustica';
import FiltroSequencial from './filtros/FiltroSequencial';
import FiltroSessao from './filtros/FiltroSessao';
import FiltroSituacaoAcordao from './filtros/FiltroSituacaoAcordao';
import FiltroSituacaoApreciacao from './filtros/FiltroSituacaoApreciacao';
import FiltroSituacaoImpedimentosProcesso from './filtros/FiltroSituacaoImpedimentosProcesso';
import FiltroSituacaoLiberacaoMinutaVoto from './filtros/FiltroSituacaoLiberacaoMinutaVoto';
import FiltroSituacaoMinuta from './filtros/FiltroSituacaoMinuta';
import FiltroSituacaoSustentacaoOralEletronica from './filtros/FiltroSituacaoSustentacaoOralEletronica';
import FiltroTipoJulgamento from './filtros/FiltroTipoJulgamento';
import FiltroTipoRemessaJulgamento from './filtros/FiltroTipoRemessaJulgamento';
import FiltroMovimentacoesInternas from './filtros/FiltroTramitacoesInternas';
import FiltroTranscricaoSustentacaoOralEletronica from './filtros/FiltroTranscricaoSustentacaoOralEletronica';
import FiltroVistaMesa from './filtros/FiltroVistaMesa';
import FiltroVistaRegimentalMagistrado from './filtros/FiltroVistaRegimentalMagistrado';
import FiltroVistor from './filtros/FiltroVistor';
import FiltroVotacaoComDivergencia from './filtros/FiltroVotacaoComDivergencia';
import FiltroVotacaoComRessalva from './filtros/FiltroVotacaoComRessalva';
import FiltroVotacaoComVotoConvergente from './filtros/FiltroVotacaoComVotoConvergente';
import FiltroVotacaoComVotoDiferenteDeConfirmado from './filtros/FiltroVotacaoComVotoDiferenteDeConfirmado';
import FiltroVotacaoComVotoDiferenteDeConfirmadoPorMagistrado from './filtros/FiltroVotacaoComVotoDiferenteDeConfirmadoPorMagistrado';
import FiltroVotacaoComVotoNaoRegistrado from './filtros/FiltroVotacaoComVotoNaoRegistrado';
import FiltroVotacaoComVotoRevogado from './filtros/FiltroVotacaoComVotoRevogado';
import FiltroCienciaDomicilioEletronico from './filtros/FiltroCienciaDomicilioEletronico';

export default class FiltrosSalaSessao extends Filtros {
    static ordemFiltroRapido = [
        'filtroVistaMesa',
        'filtroAdvogadoPreferenciaSustentacaoOralPresenca',
        'filtroSituacaoLiberacaoMinutaVoto',
        'filtroAdvogadoModoParticipacao',
        'filtroSituacaoMinuta',
        'filtroTipoJulgamento',
        'filtroRetornoVistaRegimental',
        'filtroTipoRemessaJulgamento',
        'filtroRetornoAdiamento',
        'filtroSituacaoApreciacao',
        'filtroSegredoJustica',
        'filtroSituacaoImpedimentosProcesso',
        'filtroCorreJunto',
        'filtroProcessosAssociados',
        'filtroDestaques',
        'filtroPeticoesPendentes',
        'filtroAnotacoes',
        'filtroVotacaoComRessalva',
        'filtroVotacaoComDivergencia',
        'filtroVotacaoComVotoRevogado',
        'filtroVotacaoComVotoDiferenteDeConfirmado',
        'filtroQuantidadePartesAutoras',
        'filtroForaOrgaoJudicante',
        'filtroSituacaoSustentacaoOralEletronica',
        'filtroCertidaoPendente',
        'filtroSituacaoAcordao'
    ];

    ordem = 0;

    filtroNumeroProcesso = new FiltroNumeroProcesso({
        idFiltro: 'filtroNumeroProcesso',
        ordem: this.ordem++,
        store: this.store
    });

    filtroSessao = new FiltroSessao({
        idFiltro: 'filtroSessao',
        ordem: this.ordem++,
        store: this.store
    });

    filtroGabineteRelator = new FiltroGabineteRelator({
        idFiltro: 'filtroGabineteRelator',
        ordem: this.ordem++,
        store: this.store
    });

    filtroNomeRelator = new FiltroNomeRelator({
        idFiltro: 'filtroNomeRelator',
        ordem: this.ordem++,
        store: this.store
    });

    filtroVistor = new FiltroVistor({
        idFiltro: 'filtroVistor',
        ordem: this.ordem++,
        store: this.store
    });

    filtroTipoJulgamento = new FiltroTipoJulgamento({
        idFiltro: 'filtroTipoJulgamento',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroTipoJulgamento', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroTipoRemessaJulgamento = new FiltroTipoRemessaJulgamento({
        idFiltro: 'filtroTipoRemessaJulgamento',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroTipoRemessaJulgamento',
            FiltrosSalaSessao.ordemFiltroRapido
        )
    });

    filtroMotivoRemessaJulgamento = new FiltroMotivoRemessaJulgamento({
        idFiltro: 'filtroMotivoRemessaJulgamento',
        ordem: this.ordem++,
        store: this.store
    });

    filtroClasseJudicial = new FiltroClasseJudicial({
        idFiltro: 'filtroClasseJudicial',
        ordem: this.ordem++,
        store: this.store
    });

    filtroClasseJudicialCompleta = new FiltroClasseJudicialCompleta({
        idFiltro: 'filtroClasseJudicialCompleta',
        ordem: this.ordem++,
        store: this.store
    });

    filtroRegiaoProcesso = new FiltroRegiaoProcesso({
        idFiltro: 'filtroRegiaoProcesso',
        ordem: this.ordem++,
        store: this.store
    });

    filtroQuorum = new FiltroQuorum({
        idFiltro: 'filtroQuorum',
        ordem: this.ordem++,
        store: this.store
    });

    filtroQuorumMinimo = new FiltroQuorumMinimo({
        idFiltro: 'filtroQuorumMinimo',
        ordem: this.ordem++,
        store: this.store
    });

    filtroComposicao = new FiltroComposicao({
        idFiltro: 'filtroComposicao',
        ordem: this.ordem++,
        store: this.store
    });

    filtroSituacaoMinuta = new FiltroSituacaoMinuta({
        idFiltro: 'filtroSituacaoMinuta',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroSituacaoMinuta', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroCertidaoPendente = new FiltroCertidaoPendente({
        idFiltro: 'filtroCertidaoPendente',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroCertidaoPendente', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroSituacaoAcordao = new FiltroSituacaoAcordao({
        idFiltro: 'filtroSituacaoAcordao',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroSituacaoAcordao', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroSituacaoApreciacao = new FiltroSituacaoApreciacao({
        idFiltro: 'filtroSituacaoApreciacao',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroSituacaoApreciacao', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroResultadoApreciacaoSessaoAnterior = new FiltroResultadoApreciacaoSessaoAnterior({
        idFiltro: 'filtroResultadoApreciacaoSessaoAnterior',
        ordem: this.ordem++,
        store: this.store
    });

    filtroResultadosApreciacaoSessoesAnteriores = new FiltroResultadosApreciacaoSessoesAnteriores({
        idFiltro: 'filtroResultadosApreciacaoSessoesAnteriores',
        ordem: this.ordem++,
        store: this.store
    });

    filtroVistaRegimentalMagistrado = new FiltroVistaRegimentalMagistrado({
        idFiltro: 'filtroVistaRegimentalMagistrado',
        ordem: this.ordem++,
        store: this.store
    });

    filtroAdvogadoPreferenciaSustentacaoOralPresenca = new FiltroAdvogadoPreferenciaSustentacaoOralPresenca({
        idFiltro: 'filtroAdvogadoPreferenciaSustentacaoOralPresenca',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroAdvogadoPreferenciaSustentacaoOralPresenca',
            FiltrosSalaSessao.ordemFiltroRapido
        )
    });

    filtroAdvogadoModoParticipacao = new FiltroAdvogadoModoParticipacao({
        idFiltro: 'filtroAdvogadoModoParticipacao',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroAdvogadoModoParticipacao',
            FiltrosSalaSessao.ordemFiltroRapido
        )
    });

    filtroAdvogadoNome = new FiltroAdvogadoNome({
        idFiltro: 'filtroAdvogadoNome',
        ordem: this.ordem++,
        store: this.store
    });

    filtroAdvogadoPreferenciaSustentacaoOralUfOabOutraUf = new FiltroAdvogadoPreferenciaSustentacaoOralUfOabOutraUf({
        idFiltro: 'filtroAdvogadoPreferenciaSustentacaoOralUfOabOutraUf',
        ordem: this.ordem++,
        store: this.store
    });

    filtroAdvogadoPreferenciaSustentacaoOralUfOab = new FiltroAdvogadoPreferenciaSustentacaoOralUfOab({
        idFiltro: 'filtroAdvogadoPreferenciaSustentacaoOralUfOab',
        ordem: this.ordem++,
        store: this.store
    });

    filtroSituacaoSustentacaoOralEletronica = new FiltroSituacaoSustentacaoOralEletronica({
        idFiltro: 'filtroSituacaoSustentacaoOralEletronica',
        ordem: this.ordem++,
        store: this.store
    });

    filtroTranscricaoSustentacaoOralEletronica = new FiltroTranscricaoSustentacaoOralEletronica({
        idFiltro: 'filtroTranscricaoSustentacaoOralEletronica',
        ordem: this.ordem++,
        store: this.store
    });

    filtroMovimentoDecisao = new FiltroMovimentoDecisao({
        idFiltro: 'filtroMovimentoDecisao',
        ordem: this.ordem++,
        store: this.store
    });

    filtroMovimentoDecisaoSessaoAnterior = new FiltroMovimentoDecisaoSessaoAnterior({
        idFiltro: 'filtroMovimentoDecisaoSessaoAnterior',
        ordem: this.ordem++,
        store: this.store
    });

    filtroMovimentoDecisaoJulgadoSessaoAnterior = new FiltroMovimentoDecisaoJulgadoSessaoAnterior({
        idFiltro: 'filtroMovimentoDecisaoJulgadoSessaoAnterior',
        ordem: this.ordem++,
        store: this.store
    });

    filtroMesmaFaseSessaoAnterior = new FiltroMesmaFaseSessaoAnterior({
        idFiltro: 'filtroMesmaFaseSessaoAnterior',
        ordem: this.ordem++,
        store: this.store
    });

    filtroPartes = new FiltroPartes({
        idFiltro: 'filtroPartes',
        ordem: this.ordem++,
        store: this.store
    });

    filtroOrigem = new FiltroOrigem({
        idFiltro: 'filtroOrigem',
        ordem: this.ordem++,
        store: this.store
    });

    filtroProcessoImportadoSIJ = new FiltroProcessoImportadoSIJ({
        idFiltro: 'filtroProcessoImportadoSIJ',
        ordem: this.ordem++,
        store: this.store
    });

    filtroIncluidoPeloGabinete = new FiltroIncluidoPeloGabinete({
        idFiltro: 'filtroIncluidoPeloGabinete',
        ordem: this.ordem++,
        store: this.store
    });

    filtroSituacaoLiberacaoMinutaVoto = new FiltroSituacaoLiberacaoMinutaVoto({
        idFiltro: 'filtroSituacaoLiberacaoMinutaVoto',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroSituacaoLiberacaoMinutaVoto',
            FiltrosSalaSessao.ordemFiltroRapido
        )
    });

    filtroVistaMesa = new FiltroVistaMesa({
        idFiltro: 'filtroVistaMesa',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroVistaMesa', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroRetornoVistaRegimental = new FiltroRetornoVistaRegimental({
        idFiltro: 'filtroRetornoVistaRegimental',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroRetornoVistaRegimental',
            FiltrosSalaSessao.ordemFiltroRapido
        )
    });

    filtroRetornoAdiamento = new FiltroRetornoAdiamento({
        idFiltro: 'filtroRetornoAdiamento',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroRetornoAdiamento', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroSequencial = new FiltroSequencial({
        idFiltro: 'filtroSequencial',
        ordem: this.ordem++,
        store: this.store
    });

    filtroSegredoJustica = new FiltroSegredoJustica({
        idFiltro: 'filtroSegredoJustica',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroSegredoJustica', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroImpedimentos = new FiltroImpedimentos({
        idFiltro: 'filtroImpedimentos',
        ordem: this.ordem++,
        store: this.store
    });

    filtroSituacaoImpedimentosProcesso = new FiltroSituacaoImpedimentosProcesso({
        idFiltro: 'filtroSituacaoImpedimentosProcesso',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroSituacaoImpedimentosProcesso',
            FiltrosSalaSessao.ordemFiltroRapido
        )
    });

    filtroImpedimentosMagistrado = new FiltroImpedimentosMagistrado({
        idFiltro: 'filtroImpedimentosMagistrado',
        ordem: this.ordem++,
        store: this.store
    });

    filtroDestaques = new FiltroDestaques({
        idFiltro: 'filtroDestaques',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroDestaques', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroDestaquesPorMagistrado = new FiltroDestaquesPorMagistrado({
        idFiltro: 'filtroDestaquesPorMagistrado',
        ordem: this.ordem++,
        store: this.store
    });

    filtroPeticoesPendentes = new FiltroPeticoesPendentes({
        idFiltro: 'filtroPeticoesPendentes',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroPeticoesPendentes', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroCorreJunto = new FiltroCorreJunto({
        idFiltro: 'filtroCorreJunto',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroCorreJunto', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroProcessosAssociados = new FiltroProcessosAssociados({
        idFiltro: 'filtroProcessosAssociados',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroProcessosAssociados', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroAnotacoes = new FiltroAnotacoes({
        idFiltro: 'filtroAnotacoes',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroAnotacoes', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroAnotacoesCurtas = new FiltroAnotacoesCurtas({
        idFiltro: 'filtroAnotacoesCurtas',
        ordem: this.ordem++,
        store: this.store
    });

    filtroAnotacoesComplementares = new FiltroAnotacoesComplementares({
        idFiltro: 'filtroAnotacoesComplementares',
        ordem: this.ordem++,
        store: this.store
    });

    filtroVotacaoComVotoNaoRegistrado = new FiltroVotacaoComVotoNaoRegistrado({
        idFiltro: 'filtroVotacaoComVotoNaoRegistrado',
        ordem: this.ordem++,
        store: this.store
    });

    filtroVotacaoComVotoConvergente = new FiltroVotacaoComVotoConvergente({
        idFiltro: 'filtroVotacaoComVotoConvergente',
        ordem: this.ordem++,
        store: this.store
    });

    filtroVotacaoComRessalva = new FiltroVotacaoComRessalva({
        idFiltro: 'filtroVotacaoComRessalva',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido('filtroVotacaoComRessalva', FiltrosSalaSessao.ordemFiltroRapido)
    });

    filtroVotacaoComDivergencia = new FiltroVotacaoComDivergencia({
        idFiltro: 'filtroVotacaoComDivergencia',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroVotacaoComDivergencia',
            FiltrosSalaSessao.ordemFiltroRapido
        )
    });

    filtroVotacaoComVotoDiferenteDeConfirmado = new FiltroVotacaoComVotoDiferenteDeConfirmado({
        idFiltro: 'filtroVotacaoComVotoDiferenteDeConfirmado',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroVotacaoComVotoDiferenteDeConfirmado',
            FiltrosSalaSessao.ordemFiltroRapido
        )
    });

    filtroVotacaoComVotoDiferenteDeConfirmadoPorMagistrado = new FiltroVotacaoComVotoDiferenteDeConfirmadoPorMagistrado(
        {
            idFiltro: 'filtroVotacaoComVotoDiferenteDeConfirmadoPorMagistrado',
            ordem: this.ordem++,
            store: this.store
        }
    );

    filtroVotacaoComVotoRevogado = new FiltroVotacaoComVotoRevogado({
        idFiltro: 'filtroVotacaoComVotoRevogado',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroVotacaoComVotoRevogado',
            FiltrosSalaSessao.ordemFiltroRapido
        )
    });

    filtroMovimentosOuDecisaoAusentes = new FiltroMovimentosOuDecisaoAusentes({
        idFiltro: 'filtroMovimentosOuDecisaoAusentes',
        ordem: this.ordem++,
        store: this.store
    });

    filtroObrigatoriedadePublicacaoAcordao = new FiltroObrigatoriedadePublicacaoAcordao({
        idFiltro: 'filtroObrigatoriedadePublicacaoAcordao',
        ordem: this.ordem++,
        store: this.store
    });

    filtroMovimentosEncaminhadosPJe = new FiltroMovimentosEncaminhadosPje({
        idFiltro: 'filtroMovimentosEncaminhadosPJe',
        ordem: this.ordem++,
        store: this.store
    });

    filtroCertidoesEncaminhadasPJe = new FiltroCertidoesEncaminhadasPje({
        idFiltro: 'filtroCertidoesEncaminhadasPJe',
        ordem: this.ordem++,
        store: this.store
    });

    filtroAcordaosEncaminhadosPJe = new FiltroAcordaosEncaminhadosPje({
        idFiltro: 'filtroAcordaosEncaminhadosPJe',
        ordem: this.ordem++,
        store: this.store
    });

    filtroProcessoLiberadoPelaSecretaria = new FiltroProcessoLiberadoPelaSecretaria({
        idFiltro: 'filtroProcessoLiberadoPelaSecretaria',
        ordem: this.ordem++,
        store: this.store
    });

    filtroQuantidadePartesAutoras = new FiltroQuantidadePartesAutoras({
        idFiltro: 'filtroQuantidadePartesAutoras',
        ordem: this.ordem++,
        store: this.store,
        ordemFiltroRapido: Filtros.posicaoFiltroRapido(
            'filtroQuantidadePartesAutoras',
            FiltrosSalaSessao.ordemFiltroRapido
        )
    });

    filtroInformacaoIntimacao = new FiltroInformacaoIntimacao({
        idFiltro: 'filtroInformacaoIntimacao',
        ordem: this.ordem++,
        store: this.store
    });

    filtroIndicadores = new FiltroIndicadores({
        idFiltro: 'filtroIndicadores',
        ordem: this.ordem++,
        store: this.store
    });

    filtroMovimentacoesInternas = new FiltroMovimentacoesInternas({
        idFiltro: 'filtroMovimentacoesInternas',
        ordem: this.ordem++,
        store: this.store
    });

    filtroDomicilioEletronico = new FiltroDomicilioEletronico({
        idFiltro: 'filtroDomicilioEletronico',
        ordem: this.ordem++,
        store: this.store
    });

    filtroIntimacaoDomicilioEletronico = new FiltroIntimacaoDomicilioEletronico({
        idFiltro: 'filtroIntimacaoDomicilioEletronico',
        ordem: this.ordem++,
        store: this.store
    });

    filtroCienciaDomicilioEletronico = new FiltroCienciaDomicilioEletronico({
        idFiltro: 'filtroCienciaDomicilioEletronico',
        ordem: this.ordem++,
        store: this.store
    });

    constructor(props) {
        super(props);

        makeObservable(this, {
            ordem: false,
            filtroMotivoRemessaJulgamento: observable,
            filtroMesmaFaseSessaoAnterior: observable,
            filtroProcessosAssociados: observable,
            filtroNumeroProcesso: observable,
            filtroSessao: observable,
            filtroGabineteRelator: observable,
            filtroNomeRelator: observable,
            filtroVistor: observable,
            filtroTipoJulgamento: observable,
            filtroTipoRemessaJulgamento: observable,
            filtroClasseJudicial: observable,
            filtroClasseJudicialCompleta: observable,
            filtroRegiaoProcesso: observable,
            filtroQuorum: observable,
            filtroQuorumMinimo: observable,
            filtroComposicao: observable,
            filtroSituacaoMinuta: observable,
            filtroCertidaoPendente: observable,
            filtroSituacaoAcordao: observable,
            filtroSituacaoApreciacao: observable,
            filtroResultadoApreciacaoSessaoAnterior: observable,
            filtroResultadosApreciacaoSessoesAnteriores: observable,
            filtroVistaRegimentalMagistrado: observable,
            filtroAdvogadoPreferenciaSustentacaoOralPresenca: observable,
            filtroAdvogadoModoParticipacao: observable,
            filtroAdvogadoNome: observable,
            filtroAdvogadoPreferenciaSustentacaoOralUfOabOutraUf: observable,
            filtroAdvogadoPreferenciaSustentacaoOralUfOab: observable,
            filtroMovimentoDecisao: observable,
            filtroMovimentoDecisaoSessaoAnterior: observable,
            filtroMovimentoDecisaoJulgadoSessaoAnterior: observable,
            filtroPartes: observable,
            filtroOrigem: observable,
            filtroProcessoImportadoSIJ: observable,
            filtroIncluidoPeloGabinete: observable,
            filtroSituacaoLiberacaoMinutaVoto: observable,
            filtroVistaMesa: observable,
            filtroRetornoVistaRegimental: observable,
            filtroRetornoAdiamento: observable,
            filtroSequencial: observable,
            filtroSegredoJustica: observable,
            filtroImpedimentos: observable,
            filtroSituacaoImpedimentosProcesso: observable,
            filtroImpedimentosMagistrado: observable,
            filtroDestaques: observable,
            filtroDestaquesPorMagistrado: observable,
            filtroPeticoesPendentes: observable,
            filtroCorreJunto: observable,
            filtroAnotacoes: observable,
            filtroAnotacoesCurtas: observable,
            filtroAnotacoesComplementares: observable,
            filtroVotacaoComVotoNaoRegistrado: observable,
            filtroVotacaoComVotoConvergente: observable,
            filtroVotacaoComRessalva: observable,
            filtroVotacaoComDivergencia: observable,
            filtroVotacaoComVotoDiferenteDeConfirmado: observable,
            filtroVotacaoComVotoDiferenteDeConfirmadoPorMagistrado: observable,
            filtroVotacaoComVotoRevogado: observable,
            filtroMovimentosOuDecisaoAusentes: observable,
            filtroObrigatoriedadePublicacaoAcordao: observable,
            filtroMovimentosEncaminhadosPJe: observable,
            filtroCertidoesEncaminhadasPJe: observable,
            filtroAcordaosEncaminhadosPJe: observable,
            filtroProcessoLiberadoPelaSecretaria: observable,
            filtroQuantidadePartesAutoras: observable,
            filtroInformacaoIntimacao: observable,
            filtroSituacaoSustentacaoOralEletronica: observable,
            filtroTranscricaoSustentacaoOralEletronica: observable,
            filtroMovimentacoesInternas: observable,
            filtroIndicadores: observable,
            filtroDomicilioEletronico: observable,
            filtroIntimacaoDomicilioEletronico: observable,
            filtroCienciaDomicilioEletronico: observable
        });
    }
}
